<app-header></app-header>

<div class="flex mt-2">
    <app-sidebar optionMenu="9"></app-sidebar>


    <div class="pt-5 pb-10 w-full md:pl-11 pr-8 lg:pl-10 pr-16">
        <div class="mx-auto max-w-screen-xl flex justify-between">
            <h1 class="text-2xl font-bold leading-8 mb-5">Apertura Home</h1>

            <button (click)="saveArticles()" [disabled]="!isButtonEnabled"
                class="w-36 h-12 bg-purple-purple6 rounded-lg flex items-center justify-center">
                <p class="text-xs text-white font-medium">Guardar cambios</p>
            </button>
        </div>

        <div class="status-banner-container">

            <div *ngIf="status === 'libre'" class="status-banner status-libre">
                <div class="status-icon">✅</div>
                <div>
                    <strong class="status-title">SECCIÓN LIBRE</strong>
                    <span class="status-message">Puedes empezar a editar esta sección.</span>
                </div>
            </div>

            <div *ngIf="status === 'bloqueadoPorOtro'" class="status-banner status-ocupado">
                <div class="status-icon">🔒</div>
                <div>
                    <strong class="status-title">SECCIÓN EN USO</strong>
                    <span class="status-message">Bloqueado por: <strong>{{ lockingUser }}</strong>.</span>
                </div>
            </div>

            <div *ngIf="status === 'bloqueadoPorMi'" class="status-banner status-propio">
                <div class="status-icon">👤</div>
                <div>
                    <strong class="status-title">BLOQUEADO POR TI</strong>
                    <span class="status-message">Tienes el control de esta sección. Tus cambios están a salvo.</span>
                </div>
            </div>

        </div>



        <div class="bg-white rounded-2xl shadow-md mx-auto mt-8">
            <div class="pt-5 pb-5 pl-10 pr-10">
                <div class="flex justify-between">
                    <div class="flex flex-col gap-2 w-80">
                        <label class="text-dark-light text-base font-semibold">Sección</label>
                        <select [(ngModel)]="selectedSection" (change)="onSectionChange()" name="selectedSection"
                            class="h-12 py-2 px-4 bg-light-dark" required>

                            <option *ngFor="let section of sections" [value]="section.key">
                                {{ section.name | titlecase }}
                            </option>

                        </select>
                        <div *ngIf="!selectedSection" class="text-red-500 text-sm mt-1">
                            La sección es obligatoria.
                        </div>
                    </div>



                    <div class="flex flex-col gap-8 py-1">

                        <!--  SWITCH: Manual / Automatico -->
                        <div class="flex items-center justify-center gap-3">
                            <!-- Etiqueta izquierda -->
                            <span class="text-sm font-semibold" [class.text-purple-purple6]="mode === 'manual'">
                                Manual
                            </span>


                            <!-- Switch visual -->
                            <label class="relative inline-block w-12 h-6 cursor-pointer">
                                <input #modeInput type="checkbox" name="automaticOpening" class="sr-only peer"
                                    [checked]="mode === 'automatico'" (change)="onChangeMode($event, modeInput)" />
                                <div class="w-full h-full bg-gray-300 rounded-full shadow-inner"></div>
                                <div
                                    class="absolute top-[2px] left-[2px] w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6">
                                </div>
                            </label>

                            <!-- Etiqueta derecha -->
                            <span class="text-sm font-semibold" [class.text-purple-purple6]="mode === 'automatico'">
                                Automático
                            </span>
                        </div>

                        <!-- PRIMER SWITCH: Apertura normal / emergencia -->
                        <div class="flex items-center justify-center gap-3">
                            <!-- Etiqueta izquierda -->
                            <span class="text-sm font-semibold cursor-pointer" [ngClass]="{
                                    'text-purple-purple6': !openigStatus,
                                    'text-dark-light': openigStatus
                                }" (click)="onChangeOpeningType(false)">
                                Apertura normal
                            </span>


                            <!-- Switch visual -->
                            <label class="relative inline-block w-12 h-6 cursor-pointer">
                                <input type="checkbox" class="sr-only peer" name="openigStatus"
                                    [(ngModel)]="openigStatus" (ngModelChange)="onChangeOpeningType($event)" />
                                <div class="w-full h-full bg-gray-300 rounded-full shadow-inner"></div>
                                <div
                                    class="absolute top-[2px] left-[2px] w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6">
                                </div>
                            </label>

                            <!-- Etiqueta derecha -->
                            <span class="text-sm font-semibold cursor-pointer" [ngClass]="{
                                'text-purple-purple6': openigStatus,
                                'text-dark-light': !openigStatus
                            }" (click)="onChangeOpeningType(true)">
                                Apertura emergencia
                            </span>
                        </div>

                        <!-- SEGUNDO SWITCH: Sección bloqueada / liberada -->
                        <div class="flex items-center justify-center gap-3">
                            <!-- Etiqueta izquierda -->
                            <span class="text-sm font-semibold cursor-pointer" [ngClass]="{
                            'text-purple-purple6': !isUnlocked,
                            'text-dark-light': isUnlocked
                        }" (click)="freeSection(false, false)">
                                Sección bloqueada
                            </span>

                            <!-- Switch visual -->
                            <label class="relative inline-block w-12 h-6 cursor-pointer">
                                <input type="checkbox" class="sr-only peer" name="isUnlocked" [(ngModel)]="isUnlocked"
                                    (ngModelChange)="freeSection(true, true)" />
                                <div class="w-full h-full bg-gray-300 rounded-full shadow-inner"></div>
                                <div
                                    class="absolute top-[2px] left-[2px] w-5 h-5 bg-white rounded-full shadow-md transition-transform duration-300 peer-checked:translate-x-6">
                                </div>
                            </label>

                            <!-- Etiqueta derecha -->
                            <span class="text-sm font-semibold cursor-pointer" [ngClass]="{
                            'text-purple-purple6': isUnlocked,
                            'text-dark-light': !isUnlocked
                        }" (click)="freeSection(true, true)">
                                Sección liberada
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- AGREGAR NOTA -->
            <div class="w-full h-auto p-5 bg-white shadow-lg border rounded-lg mt-5 mb-4">
                <div class="h-[70px] flex justify-between border-2 border-dashed cursor-pointer">
                    <div class="flex gap-2">
                        <div>
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="70" viewBox="0 0 32 70"
                                fill="none">
                                <rect width="32" height="70" fill="#E6E6E6" />
                                <rect x="19" y="58" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="58" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="19" y="48" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="48" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="19" y="38" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="38" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="19" y="18" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="18" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="19" y="28" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="28" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="19" y="8" width="4" height="4" rx="2" fill="#181818" />
                                <rect x="9" y="8" width="4" height="4" rx="2" fill="#181818" />
                            </svg>
                        </div>

                        <div class="w-6 h-6 mt-4 rounded-full bg-dark-dark3 flex items-center justify-center">
                            <span class="text-dark-dark2 text-xs"></span>
                        </div>

                        <div class="mt-1">
                            <p class="text-xs font-bold">Ingresa la url de tu nota en este campo:</p>
                            <div class="flex gap-2 mt-2">
                                <input type="text" [(ngModel)]="urlInput" class="rounded-lg bg-dark-dark3 w-[700px] h-7"
                                    [ngClass]="{
                                'bg-gray-300 cursor-not-allowed opacity-70': isUrlDisabled,
                                'bg-dark-dark3': !isUrlDisabled
                              }">
                            </div>
                        </div>
                    </div>

                    <div class="flex items-center">
                        <div class="w-[70px] h-[70px] rounded-lg">
                            <svg xmlns="http://www.w3.org/2000/svg" width="70" height="70" viewBox="0 0 70 70"
                                fill="none">
                                <rect width="70" height="70" rx="8" fill="#E6E6E6" />
                                <path
                                    d="M46.5 17C48.2239 17 49.8772 17.6848 51.0962 18.9038C52.3152 20.1228 53 21.7761 53 23.5V46.5C53 48.2239 52.3152 49.8772 51.0962 51.0962C49.8772 52.3152 48.2239 53 46.5 53H23.5C21.7761 53 20.1228 52.3152 18.9038 51.0962C17.6848 49.8772 17 48.2239 17 46.5V23.5C17 21.7761 17.6848 20.1228 18.9038 18.9038C20.1228 17.6848 21.7761 17 23.5 17H46.5ZM47.66 49.802L36.05 38.43C35.7967 38.1818 35.4637 38.0313 35.11 38.0053C34.7563 37.9793 34.4048 38.0795 34.118 38.288L33.95 38.428L22.336 49.802C22.7013 49.9313 23.0893 49.9973 23.5 50H46.5C46.906 50 47.298 49.93 47.66 49.802ZM46.5 20H23.5C22.5717 20 21.6815 20.3687 21.0251 21.0251C20.3687 21.6815 20 22.5717 20 23.5V46.5C20.0013 46.9173 20.07 47.3133 20.206 47.688L31.852 36.286C32.6503 35.5045 33.7109 35.0478 34.8272 35.0049C35.9436 34.9621 37.0361 35.336 37.892 36.054L38.148 36.286L49.792 47.69C49.928 47.3167 49.9973 46.92 50 46.5V23.5C50 22.5717 49.6312 21.6815 48.9749 21.0251C48.3185 20.3687 47.4283 20 46.5 20ZM41.504 24C42.6985 24 43.8441 24.4745 44.6888 25.3192C45.5335 26.1639 46.008 27.3095 46.008 28.504C46.008 29.6985 45.5335 30.8441 44.6888 31.6888C43.8441 32.5335 42.6985 33.008 41.504 33.008C40.3095 33.008 39.1639 32.5335 38.3192 31.6888C37.4745 30.8441 37 29.6985 37 28.504C37 27.3095 37.4745 26.1639 38.3192 25.3192C39.1639 24.4745 40.3095 24 41.504 24ZM41.504 27C41.1051 27 40.7226 27.1585 40.4405 27.4405C40.1585 27.7226 40 28.1051 40 28.504C40 28.9029 40.1585 29.2854 40.4405 29.5675C40.7226 29.8495 41.1051 30.008 41.504 30.008C41.9029 30.008 42.2854 29.8495 42.5675 29.5675C42.8495 29.2854 43.008 28.9029 43.008 28.504C43.008 28.1051 42.8495 27.7226 42.5675 27.4405C42.2854 27.1585 41.9029 27 41.504 27Z"
                                    fill="white" />
                            </svg>
                        </div>

                        <button (click)="addArticle()" [disabled]="isUrlDisabled"
                            class="w-20 flex flex-col items-center justify-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12ZM12 4C9.87827 4 7.84344 4.84285 6.34315 6.34315C4.84285 7.84344 4 9.87827 4 12C4 14.1217 4.84285 16.1566 6.34315 17.6569C7.84344 19.1571 9.87827 20 12 20C14.1217 20 16.1566 19.1571 17.6569 17.6569C19.1571 16.1566 20 14.1217 20 12C20 9.87827 19.1571 7.84344 17.6569 6.34315C16.1566 4.84285 14.1217 4 12 4Z"
                                    fill="#181818" fill-opacity="0.7" />
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M13 7C13 6.73478 12.8946 6.48043 12.7071 6.29289C12.5196 6.10536 12.2652 6 12 6C11.7348 6 11.4804 6.10536 11.2929 6.29289C11.1054 6.48043 11 6.73478 11 7V11H7C6.73478 11 6.48043 11.1054 6.29289 11.2929C6.10536 11.4804 6 11.7348 6 12C6 12.2652 6.10536 12.5196 6.29289 12.7071C6.48043 12.8946 6.73478 13 7 13H11V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V13H17C17.2652 13 17.5196 12.8946 17.7071 12.7071C17.8946 12.5196 18 12.2652 18 12C18 11.7348 17.8946 11.4804 17.7071 11.2929C17.5196 11.1054 17.2652 11 17 11H13V7Z"
                                    fill="#181818" fill-opacity="0.7" />
                            </svg>
                            <p class="text-xs font-medium">Agregar nota</p>
                        </button>
                    </div>
                </div>
            </div>

            <div class="bg-white rounded-2xl shadow-md mx-auto mt-8 p-10">

                <!-- NOTAS APERTURA -->
                <div *ngIf="!openigStatus">
                    <h3 class="text-base font-semibold">Notas apertura</h3>
                    <h5 class="text-xs text-dark-light mb-5">*Cantidad requerida: 7 notas</h5>

                    <div cdkDropList id="listaApertura" [cdkDropListData]="notasNormalList"
                        [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="drop($event)"
                        class="w-full h-auto p-5 mb-4">

                        <div *ngIf="notasNormalList.length === 0" class="text-sm text-gray-400 italic">
                            No hay notas de apertura aún.
                        </div>

                        <div *ngFor="let nota of notasNormalList; let i = index" cdkDrag
                            class="h-[70px] flex justify-between border-2 border-dashed mb-5 cursor-pointer">
                            <div class="flex gap-2">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="70" viewBox="0 0 32 70"
                                        fill="none">
                                        <rect width="32" height="70" fill="#D6E0FF" />
                                        <rect x="19" y="58" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="58" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="19" y="48" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="48" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="19" y="38" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="38" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="19" y="18" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="18" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="19" y="28" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="28" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="19" y="8" width="4" height="4" rx="2" fill="#1F54FF" />
                                        <rect x="9" y="8" width="4" height="4" rx="2" fill="#1F54FF" />
                                    </svg>
                                </div>

                                <div class="w-6 h-6 mt-4 rounded-full bg-blue-blue1 flex items-center justify-center">
                                    <span class="text-blue-blue2 text-xs">{{ getConsecutiveIndex(i, 'normal') }}</span>
                                </div>

                                <div class="mt-4">
                                    <p class="text-sm font-bold">{{ nota.title }}</p>
                                    <div class="flex gap-2 mt-2" *ngIf="nota.mostrarTituloHome">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM7.84533 10.4267L11.1787 6.42667L10.1547 5.57333L7.288 9.01267L5.80467 7.52867L4.862 8.47133L6.862 10.4713L7.378 10.9873L7.84533 10.4267Z"
                                                fill="#181818" fill-opacity="0.7" />
                                        </svg>
                                        <p class="text-xs">Este artículo contiene título home</p>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center">
                                <div class="w-[70px] h-[70px] rounded-lg">
                                    <img [src]="nota.image.src" class="rounded-lg" [alt]="nota.image.alt">
                                </div>

                                <div (click)="deleteArticle(i, 'normal')" class="w-20 flex justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path
                                            d="M7 21C6.45 21 5.97934 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6C4.71667 6 4.47934 5.904 4.288 5.712C4.09667 5.52 4.00067 5.28267 4 5C3.99934 4.71733 4.09534 4.48 4.288 4.288C4.48067 4.096 4.718 4 5 4H9C9 3.71667 9.096 3.47933 9.288 3.288C9.48 3.09667 9.71734 3.00067 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71733 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71733 20 5C19.9993 5.28267 19.9033 5.52033 19.712 5.713C19.5207 5.90567 19.2833 6.00133 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.47933 10.712 8.288C10.52 8.09667 10.2827 8.00067 10 8C9.71734 7.99933 9.48 8.09533 9.288 8.288C9.096 8.48067 9 8.718 9 9V16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17ZM14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.47933 14.712 8.288C14.52 8.09667 14.2827 8.00067 14 8C13.7173 7.99933 13.48 8.09533 13.288 8.288C13.096 8.48067 13 8.718 13 9V16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17Z"
                                            fill="#181818" fill-opacity="0.7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- NOTAS EMERGENCIA -->
                <div *ngIf="openigStatus">
                    <h3 class="text-base font-semibold">Notas emergencia</h3>
                    <h5 class="text-xs text-dark-light mb-5">* Cantidad requerida: mínimo 1 nota, máximo 5 notas</h5>

                    <div cdkDropList id="listaEmergencia" [cdkDropListData]="notasEmergenciaList"
                        [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="drop($event)"
                        class="w-full h-auto p-5 mb-4">

                        <div *ngIf="notasEmergenciaList.length === 0" class="text-sm text-gray-400 italic">
                            No hay notas de emergencia aún.
                        </div>

                        <div *ngFor="let notaE of notasEmergenciaList; let i = index" cdkDrag
                            class="h-[70px] flex justify-between border-2 border-dashed mb-5 cursor-pointer">

                            <div class="flex gap-2">
                                <div>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="70" viewBox="0 0 32 70"
                                        fill="none">
                                        <rect width="32" height="70" fill="#FFBDD8" />
                                        <rect x="19" y="58" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="58" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="19" y="48" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="48" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="19" y="38" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="38" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="19" y="18" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="18" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="19" y="28" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="28" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="19" y="8" width="4" height="4" rx="2" fill="#F20066" />
                                        <rect x="9" y="8" width="4" height="4" rx="2" fill="#F20066" />
                                    </svg>
                                </div>

                                <div class="w-6 h-6 mt-4 rounded-full bg-pink-light flex items-center justify-center">
                                    <span class="text-pink-dark text-xs">{{ getConsecutiveIndex(i, 'emergencia')
                                        }}</span>
                                </div>

                                <div class="mt-4">
                                    <p class="text-sm font-bold">{{ notaE.title }}</p>
                                    <div class="flex gap-2 mt-2" *ngIf="notaE.mostrarTituloHome">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            viewBox="0 0 16 16" fill="none">
                                            <path fill-rule="evenodd" clip-rule="evenodd"
                                                d="M8 14C8.78793 14 9.56815 13.8448 10.2961 13.5433C11.0241 13.2417 11.6855 12.7998 12.2426 12.2426C12.7998 11.6855 13.2417 11.0241 13.5433 10.2961C13.8448 9.56815 14 8.78793 14 8C14 7.21207 13.8448 6.43185 13.5433 5.7039C13.2417 4.97595 12.7998 4.31451 12.2426 3.75736C11.6855 3.20021 11.0241 2.75825 10.2961 2.45672C9.56815 2.15519 8.78793 2 8 2C6.4087 2 4.88258 2.63214 3.75736 3.75736C2.63214 4.88258 2 6.4087 2 8C2 9.5913 2.63214 11.1174 3.75736 12.2426C4.88258 13.3679 6.4087 14 8 14ZM7.84533 10.4267L11.1787 6.42667L10.1547 5.57333L7.288 9.01267L5.80467 7.52867L4.862 8.47133L6.862 10.4713L7.378 10.9873L7.84533 10.4267Z"
                                                fill="#181818" fill-opacity="0.7" />
                                        </svg>
                                        <p class="text-xs">Este artículo contiene título home</p>
                                    </div>
                                </div>
                            </div>

                            <div class="flex items-center">
                                <div class="w-[70px] h-[70px] rounded-lg">
                                    <img [src]="notaE.image.src" class="rounded-lg" [alt]="notaE.image.alt">
                                </div>

                                <div (click)="deleteArticle(i, 'emergencia')" class="w-20 flex justify-center">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none">
                                        <path
                                            d="M7 21C6.45 21 5.97934 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6C4.71667 6 4.47934 5.904 4.288 5.712C4.09667 5.52 4.00067 5.28267 4 5C3.99934 4.71733 4.09534 4.48 4.288 4.288C4.48067 4.096 4.718 4 5 4H9C9 3.71667 9.096 3.47933 9.288 3.288C9.48 3.09667 9.71734 3.00067 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71733 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71733 20 5C19.9993 5.28267 19.9033 5.52033 19.712 5.713C19.5207 5.90567 19.2833 6.00133 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.47933 10.712 8.288C10.52 8.09667 10.2827 8.00067 10 8C9.71734 7.99933 9.48 8.09533 9.288 8.288C9.096 8.48067 9 8.718 9 9V16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17ZM14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.47933 14.712 8.288C14.52 8.09667 14.2827 8.00067 14 8C13.7173 7.99933 13.48 8.09533 13.288 8.288C13.096 8.48067 13 8.718 13 9V16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17Z"
                                            fill="#181818" fill-opacity="0.7" />
                                    </svg>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- NOTAS GRILLA  -->
                <div>
                    <h3 class="text-base font-semibold">Notas grilla</h3>
                    <h5 class="text-xs text-dark-light mb-5">* Cantidad faltante: {{16 - notasGrillaList.length }}
                        notas.
                        <br> * Cantidad requerida: 16 notas.
                    </h5>

                    <div cdkDropList id="listaGrilla" [cdkDropListData]="notasGrillaList"
                        [cdkDropListConnectedTo]="connectedDropLists" (cdkDropListDropped)="drop($event)"
                        class="w-full h-auto p-5 mb-4">

                        <div *ngIf="notasGrillaList.length === 0" class="text-sm text-gray-400 italic">
                            No hay notas de grilla aún.
                        </div>

                        <div class="grid grid-cols-2 gap-2">
                            <div *ngFor="let notaG of notasGrillaList; let i = index" cdkDrag
                                class="h-[70px] flex justify-between  mb-5 cursor-pointer">

                                <div class="w-[50px] flex items-center justify-center">
                                    <div
                                        class="w-6 h-6 mt-4 rounded-full bg-purple-purple7 flex items-center justify-center">
                                        <span class="text-purple-purple8 text-xs">{{ getConsecutiveIndex(i, 'grilla')
                                            }}</span>
                                    </div>
                                </div>

                                <div class="flex border-2 border-dashed">
                                    <div class="flex gap-2 ">

                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="70"
                                                viewBox="0 0 32 70" fill="none">
                                                <rect width="32" height="70" fill="#E9CCFF" />
                                                <rect x="19" y="58" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="58" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="19" y="48" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="48" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="19" y="38" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="38" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="19" y="18" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="18" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="19" y="28" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="28" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="19" y="8" width="4" height="4" rx="2" fill="#7200CC" />
                                                <rect x="9" y="8" width="4" height="4" rx="2" fill="#7200CC" />
                                            </svg>
                                        </div>

                                        <div class="mt-1 mr-2">
                                            <p class="text-sm font-bold">{{ notaG.title }}</p>
                                        </div>
                                    </div>

                                    <div class="flex items-center">
                                        <div class="w-[70px] h-[70px] rounded-lg">
                                            <img [src]="notaG.image.src" class="rounded-lg" [alt]="notaG.image.alt">
                                        </div>

                                        <div (click)="deleteArticle(i, 'grilla')" class="w-[70px] flex justify-center">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none">
                                                <path
                                                    d="M7 21C6.45 21 5.97934 20.8043 5.588 20.413C5.19667 20.0217 5.00067 19.5507 5 19V6C4.71667 6 4.47934 5.904 4.288 5.712C4.09667 5.52 4.00067 5.28267 4 5C3.99934 4.71733 4.09534 4.48 4.288 4.288C4.48067 4.096 4.718 4 5 4H9C9 3.71667 9.096 3.47933 9.288 3.288C9.48 3.09667 9.71734 3.00067 10 3H14C14.2833 3 14.521 3.096 14.713 3.288C14.905 3.48 15.0007 3.71733 15 4H19C19.2833 4 19.521 4.096 19.713 4.288C19.905 4.48 20.0007 4.71733 20 5C19.9993 5.28267 19.9033 5.52033 19.712 5.713C19.5207 5.90567 19.2833 6.00133 19 6V19C19 19.55 18.8043 20.021 18.413 20.413C18.0217 20.805 17.5507 21.0007 17 21H7ZM17 6H7V19H17V6ZM10 17C10.2833 17 10.521 16.904 10.713 16.712C10.905 16.52 11.0007 16.2827 11 16V9C11 8.71667 10.904 8.47933 10.712 8.288C10.52 8.09667 10.2827 8.00067 10 8C9.71734 7.99933 9.48 8.09533 9.288 8.288C9.096 8.48067 9 8.718 9 9V16C9 16.2833 9.096 16.521 9.288 16.713C9.48 16.905 9.71734 17.0007 10 17ZM14 17C14.2833 17 14.521 16.904 14.713 16.712C14.905 16.52 15.0007 16.2827 15 16V9C15 8.71667 14.904 8.47933 14.712 8.288C14.52 8.09667 14.2827 8.00067 14 8C13.7173 7.99933 13.48 8.09533 13.288 8.288C13.096 8.48067 13 8.718 13 9V16C13 16.2833 13.096 16.521 13.288 16.713C13.48 16.905 13.7173 17.0007 14 17Z"
                                                    fill="#181818" fill-opacity="0.7" />
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>